module.exports = __webpack_public_path__ + "static/img/access-for-all__small.3183b4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/primary/access-for-all__small.jpg
// module id = B6ZF
// module chunks = 1